import type { AudiencePreview, CampaignMessageAssignment, CampaignRecipientPlan } from "./campaignBuilderApi";

/** Qualified audience rows intersected with contacts planned for a journey email step. */
export function plannedRecipientsForEmailStep(
  stepId: string,
  recipientPlan: CampaignRecipientPlan | null | undefined,
  audience: AudiencePreview,
): AudiencePreview["qualified"] {
  const assignments: CampaignMessageAssignment[] = recipientPlan?.by_step?.[stepId] ?? [];
  if (!assignments.length) return [];
  const qualifiedById = new Map(audience.qualified.map((c) => [c.contact_id, c]));
  const out: AudiencePreview["qualified"] = [];
  for (const assignment of assignments) {
    if (assignment.deliverability_status !== "planned") continue;
    const qualified = qualifiedById.get(assignment.contact_id);
    const email = (qualified?.email ?? assignment.email)?.trim();
    if (!qualified || !email) continue;
    out.push({
      ...qualified,
      email,
      first_name: qualified.first_name ?? assignment.first_name ?? null,
      last_name: qualified.last_name ?? assignment.last_name ?? null,
    });
  }
  return out;
}
